const _i18n_info = {
  webShell_detect : {
    EN: `No Web Shells Detected`,
    KO: `No Web Shells Detected`,
    JP: `Web Shellsが検出されませんでした`
  }
}

const i18n_toastr = { _i18n_info }

export default i18n_toastr